<template lang="pug">
    el-dialog(
      :title="form.title", v-if="dialogVisible",
      :visible.sync="dialogVisible",
      :before-close="handleClose",
    ).max-dialog-w-1000
      .row.row-xs.align-items-center
        .col-auto
          img(:src='form.userImage').size-100px.rounded-circle.object-fit
        .col-sm.col-7
          .fs-16 {{form.userName}}
          div {{form.email}}
        .col-auto.company-sec(v-if="me.isAllCompanyAdmin")
          .fs-16 Company
          el-select(
            v-model="selectedCompany"
            placeholder="Select",
            v-on:change='handleCommand($event)',
            filterable
          )
            el-option(
              v-for='item in me.Company'
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            )
      hr
      .row.date-sec
        .col-sm-3
          .fw-b.mb-1 Date
          .fs-16.lh-24 {{ formatDate(form.expenseDate) }}
        .col-sm-4
          .fw-b.mb-1 Merchant
          .fs-16.lh-24 {{form.merchant}}
        .col-sm-2
          .fw-b.mb-1 Amount
          .fs-16.lh-24(v-if='form.splitTransactions.length > 1 || form.originalAmount')
            | {{ form.originalAmount | toUSD }}
          .fs-16.lh-24(v-else)
            | {{ form.amount | toUSD }}
        .col-sm-3
          .fw-b.mb-1 Status
          div(v-if='form.status').text-success.fs-14.lh-24
            div(v-if='form.recordStatus === null || form.recordStatus === 0').text-success.fs-14
              span PRE-AUTHORIZED
            div(v-if='form.recordStatus === 1').text-success.fs-14
              span CLEARED
            div(v-if='form.recordStatus === 3').text-success.fs-14
              span PRE-AUTHORIZED
            div(v-if='form.recordStatus === 4').text-primary.fs-14
              span REFUND
            div(v-if='form.recordStatus === 6').text-primary.fs-14
              span Reversal
          div(v-else).text-danger.fs-14
            div(v-if='form.recordStatus === 5').text-primary.fs-14
              span VERIFICATION
            div(v-else)
              span DECLINED
      hr
      div(v-if='form.status && !makeSplit').team-sec
        .row.row-xl
          .col-sm-6
            div(v-if="!form.groupName")
              .textColorDialog.fw-b Team * {{form.groupName}}
              el-select(
                v-model="groupId"
                placeholder="Select"
                @change='updateCategory(groupId)',
                filterable
              )
                el-option(
                  v-for="item in teamData"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id"
                )
            div(v-else)
              .fw-b.mb-1 Team
              el-select(
                v-model="groupId"
                placeholder="Select"
                @change='updateCategory(groupId)',
                filterable
              )
                el-option(
                  v-for="item in teamData"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id"
                )
          .col-sm-6.category
            div(v-if="form.categoryName === ''")
              div(class='textColorDialog').fw-b Category *
              el-select(
                v-model="categoryId"
                placeholder="Select"
                @change='categoryBudgetUser(categoryId)',
                filterable
              )
                el-option(
                  v-for="item in category"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                )
            div(v-else)
              .fw-b.mb-1 Category
              el-select(
                v-model="categoryId"
                placeholder="Select"
                @change='categoryBudgetUser(categoryId)',
                filterable
              )
                el-option(
                  v-for="item in category"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                )
        .row
          .col-sm-12
            .fw-b.mt-2
              el-checkbox.mb-0(
                v-if="this.form.isPhysical || this.form.isExternal"
                v-model="isChecked"
              ) Automatically Categorize Transactions for {{form.merchant}}
      //- For Future implementation
      hr(v-if="form.recordStatus===1")
      el-checkbox.mb-0(
        v-if="form.recordStatus===1"
        v-model="makeSplit"
        @change='splitAllwed'
      ) Split this transaction
      template(v-for='(component1, index) in inlineComponents')
        component(
          v-if="form.recordStatus===1 && makeSplit"
          :key='index'
          :index='index'
          v-bind:is='component1'
          :data='form.splitTransactions[index]'
          v-bind:id='index'
          v-bind:refresh='{date: new Date()}'
          :deleteData="deleteSplitTransactions"
          v-bind:myData='form.splitTransactions[index]'
          :selectedCompany='me.Company'
          @splitTransactions="splitTransactions"
          @splitRemoveTransactions="splitRemoveTransactions($event)"
          @validateTotalAmount="validateTotalAmount($event)"
        )
      hr
      .fw-b.mb-1.tags-sec
        | Tags
        .many-tag-style
          el-tag(
            v-if='form.transactionTag.length > 0'
            :disable-transitions='false'
            closable
            @close='handleCloseTag(form.transactionTag[0])'
          )
            | {{ form.transactionTag[0].name }}
        el-autocomplete.input-new-tag(
            v-if='form.transactionTag.length === 0'
            v-model="inputValue"
            :fetch-suggestions="querySearchAsync"
            placeholder="Please select Tags"
            ref='saveTagInput'
            @select="changeUETag($event)"
        ).w-100
        //- keep this code it will help in future to implement multiple tags;
        //- el-button.button-new-tag(
        //-   v-else
        //-   size='small'
        //-   @click='showInput'
        //- ) + Add Tag

      .fw-b.mb-1(v-if="form.recordStatus === 5")
        | Note
      .fw-b.mb-1(v-else)
        | {{ form.recordStatus === 2 || form.status ? "Note" : "Declined Reason" }}
      .row(v-if='form.status')
        .col-sm-12(v-if='form.pending === 1')
          div(v-if='form.descriptionFlag === 0')
            el-input(type='textarea', :rows='2', v-model='description')
          div(v-else) {{form.description}}
        .col-sm-12(v-else) {{ form.description }}
      .mb-1(v-else) {{ form.description }}

      hr
      .fw-b.md-1
        | Budget Planner
      .row
        .col-sm-12(v-if="form.card.group && form.card.category" )
          a.underline(@click='groupCliked(form.card)') {{ form.card.group.groupName }}
          a.underline(@click='categoryCliked(form.card)') {{ form.card.category.categoryName }}
        .col-sm-12(v-else)
           a.underline(@click='groupClikedPhysical(form.card)') All Teams
      hr
      div
        div(v-if='form.recordStatus === 2 || form.status === false')
          div(class="row")
            div(class='col-sm-6')
              .fw-b.mb-1 Card
              div(v-if="form.card === ''")
                div Loading...
              div(v-else)
                div(v-if="form.isPhysical")
                  credit-card(
                    @cardClicked="pCardClicked(form)"
                    is-physical-card,
                    :card='getlastFour(form.card)'
                    :employee='{"firstName": form.userName ,"lastName":""}'
                  )
                div(v-else-if="form.isExternal").row#grop-cc-card.tdExtranalCards
                  ExtranalCreditCardMgmt(
                    :item='form.card'
                    :index='form.card.id'
                  )
                div(v-else)
                  credit-card(
                    @cardClicked="vCardClicked(form)"
                    is-virtual-card,
                    :card='form.card === null ? {"last_four" : 0 } : form.card',
                    :employee='{"firstName": form.userName ,"lastName":""}'
                  )
        div(v-else)
          div(class="row row-xl")
            div(class='col-sm-6')
              .fw-b.mb-1 Receipt
              .border.p-1.border-radius
                div
                  div
                    el-upload(
                      action=''
                      :on-preview='handlePreview'
                      :on-remove='handleRemoveReceipt'
                      :before-remove="beforeRemove"
                      :file-list='fileList'
                      list-type='text',
                      :auto-upload='false',
                      :on-change='handleAvatarSuccess',
                    )
                      el-button(
                        v-if='isPermission'
                        size='small'
                        type='primary'
                      ) Click to upload

            div(class='col-sm-6 spend-card-test')
              .fw-b.mb-1(
                v-if='form.card.cardAccount'
              ) Card - {{ form.card.cardAccount.cardAccountName }}
              .fw-b.mb-1(v-else) Card - SpendHub
              div(v-if="form.card === ''")
                div Loading...
              div(v-else)
                div(v-if="form.isPhysical")
                  credit-card(
                    is-physical-card,
                    :card='getlastFour(form.card)'
                    :employee='{"firstName": form.userName ,"lastName":""}'
                    )

                div(v-else-if="form.isExternal").row#grop-cc-card.tdExtranalCards
                  ExtranalCreditCardMgmt(
                    :item='form.card'
                    :index='form.card.id'
                  )
                div(v-else)
                  credit-card(
                    is-virtual-card,
                    :card='form.card === null ? {"last_four" : 0 } : form.card',
                    :employee='{"firstName": form.userName ,"lastName":""}'
                  )

      .dialog-footer(v-if='form.status === true', slot='footer')
        el-button.f-left(
          :key="buttonRefreshkey"
          type='primary'
          @click='markFlag'
        ) {{ getFlagTitle(this.form.isFlagged) }}
        el-button(
          v-if='(form.isExternal && form.splitTransactions.length < 2)'
          type='primary'
          @click='deleteTransaction(form)'
        ) Delete
        el-button(@click='handleClose({isDelete:true})') Cancel
        el-button(type='primary' @click='submitReceipt()') Confirm

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import CreditCard from '@/components/CreditCard.vue';
import ExtranalCreditCardMgmt from '@/components/ExtranalCreditCardMgmt.vue';
import InlineSplitTransaction from '@/components/InlineSplitTransaction.vue';

// moment.tz.setDefault('America/Los_Angeles');

moment.suppressDeprecationWarnings = true;

export default {
  name: 'DialogTransactionDetail',
  components: {
    CreditCard,
    ExtranalCreditCardMgmt,
    InlineSplitTransaction,
  },
  props: {
    time: {
      default: () => { },
      type: Object,
    },
    dialogVisible: {
      default: false,
      type: Boolean,
    },
    receiptUrl: {
      default: () => [],
      type: Array,
    },
    form: {
      default: () => { },
      type: Object,
    },
  },
  data() {
    return {
      myArray: {
        id: '',
        selectedCompany: '',
        teamId: '',
        categoryId: '',
        month: '',
        year: '',
        expenseDate: '',
        amount: '',
      },
      deleteSplitTransactions: [],
      makeSplit: false,
      isDeleteOne: false,
      buttonRefreshkey: new Date().toString(),
      inlineComponents: [InlineSplitTransaction],
      teamData: [],
      selectedCompany: null,
      seletedTeam: null,
      seletedCategory: null,
      dynamicTags: [
        { value: 'One' },
        { value: 'Two' },
      ],
      allTags: [],
      inputVisible: false,
      inputValue: '',
      isPermission: false,
      allTeamCategoryPermission: false,
      isChecked: false,
      isAllChecked: false,
      uploadedReceipts: [],
      fileList: [],
      fileListRemove: [],
      imageUrl: '',
      file: null,
      fileFlag: false,
      fileType: null,
      description: '',
      groupId: '',
      categoryId: '',
      userRoleUploadReceipt: '',
      category: [],
      uploadFlag: 0,
      uploadErrorMessage: '',
      tagAction: null,
      tagId: null,
      prevTag: null,
    };
  },
  computed: {
    ...mapGetters('users', ['me', 'myTeamList', 'userCompanyId', 'getMyTeamList']),
    ...mapGetters('transactions', [
      'categoryForGroup',
      'categoryBudgetCalculation',
      'userRoleForTeam',
      'receiptData',
      'mapMerchantToCategorygroup',
      'mapMerchantToCategorygroupTime',
      'removeTransactions',
      'selectedTeams',
      'moveTransactions',
      'isAmountValid',
    ]),
    ...mapGetters('tags', ['UserTransactionsTag']),
  },
  watch: {
    removeTransactions() {
      this.handleClose();
    },
    selectedTeams() {
      this.groupId = null;
      this.categoryId = null;
      this.teamData = this.selectedTeams;
    },
    UserTransactionsTag(value) {
      this.allTags = JSON.parse(JSON.stringify(value).split('"name":').join('"value":'));
    },

    mapMerchantToCategorygroupTime() {
      const value = this.mapMerchantToCategorygroup;
      this.isChecked = false;
      if (value) {
        if (value.recordStatus === 1) {
          this.isChecked = true;
        } else {
          this.isChecked = false;
        }
      }
    },
    async time() {
      this.deleteSplitTransactions = [];
      this.makeSplit = false;
      // Entry Validate calculaton;
      this.validateTotalAmount();
      if (!this.inlineComponents.length) {
        this.inlineComponents.push(InlineSplitTransaction);
      } else if (this.form.splitTransactions) {
        if (this.form.splitTransactions.length > 1) {
          this.form.splitTransactions.forEach(() => {
            this.makeSplit = true;
            this.inlineComponents.push(InlineSplitTransaction);
          });
        }
      }

      this.isDeleteOne = false;
      if (this.dialogVisible) {
        this.selectedCompany = this.form.companyId;
        this.teamData = this.myTeamList;
        this.description = this.form.description;
        this.isChecked = false;
        this.fileList = [];
        this.receiptUrl.forEach((item) => {
          const imagData = {
            name: item.name,
            url: item.url,
            id: item.id,
          };
          this.fileList.push(imagData);
          // this.uploadedReceipts = this.fileList;
          // this.fileListRemove = [];
        });
        // Call Mapping
        this.groupId = null;
        this.categoryId = null;
        this.userId = this.form.userId;

        if (!this.form.isPhysical) {
          const {
            categoryId,
            groupId,
          } = this.form;

          if (categoryId !== '' && groupId !== '') {
            this.groupId = groupId;
            this.categoryId = categoryId;
            this.updateCategory(this.groupId, 'onCreate');
          }
        }

        if (this.form.isPhysical || this.form.isExternal) {
          const {
            categoryId,
            groupId,
            // merchantid,
            childMerchantid,
          } = this.form;


          const cardId = this.form.card.id;
          const compId = this.userCompanyId;

          const merchantMapData = {
            categoryId,
            groupId,
            cardId,
            compId,
            merchantid: childMerchantid,
          };

          if (categoryId !== '' && groupId !== '') {
            this.getMapMerchant(merchantMapData);
            this.groupId = groupId;
            this.categoryId = categoryId;
            this.updateCategory(this.groupId, 'onCreate');
          }
        }
        // Check for Permission;
        this.isPermission = false;

        // if it is my Account;
        if (this.form.userId === this.me.id) {
          this.isPermission = true;
        }

        // Check for the Permission
        this.getMyTeamList.forEach((element) => {
          element.permissions2.forEach((item) => {
            if (
              item.slug === 'remove-team-employee-receipts'
            && (element.team.id === this.selectedTeamId || element.team.groupName === 'All Teams')
            ) {
              this.isPermission = true;
            }
          });
        });
        //  call tags

        await this.getTags(this.groupId);
        this.allTags = JSON.parse(JSON.stringify(this.UserTransactionsTag).split('"name":').join('"value":'));
      }
    },
    receiptUrl(value) {
      this.fileList = [];
      value.forEach((item) => {
        const imagData = {
          name: item.name,
          url: item.url,
          id: item.id,
        };
        this.fileList.push(imagData);
        this.uploadedReceipts = this.fileList;
        this.fileListRemove = [];
      });
    },
    categoryForGroup(value) {
      this.category = value;
    },
    userRoleForTeam(value) {
      if (value.length) {
        this.userRoleUploadReceipt = value[0].role.roleName;
      }
    },
    categoryBudgetCalculation(value) {
      if (value.length) {
        if (value[0].allocated === 0) {
          // eslint-disable-next-line max-len
          const errMsg = `${this.form.userName} is not part of this budget category. Please select a budget category that this Employee belongs to.`;
          this.uploadFlag = 0;
          this.uploadErrorMessage = errMsg;
        } else if (value[0].allocated >= this.form.chartData.spent) {
          this.uploadFlag = 1;
        } else {
          this.uploadFlag = 0;
          this.uploadErrorMessage = 'Please request more budget for this category.';
        }
      } else {
        console.log('object :', value);
      }
    },
    receiptData(value) {
      if (value) {
        this.description = '';
        this.groupId = '';
        this.categoryId = '';
        this.imageUrl = '';
        this.file = null;
        this.category = [];
        this.uploadFlag = 0;
      }
    },
  },
  methods: {
    ...mapActions('transactions', [
      'getUserUnCategorized',
      'getCategoryBudgetCalculation',
      'getUserRoleForTeam',
      'mapMerchantforPhysicalCard',
      'getMapMerchant',
      'mapAllMapMerchantToTeam',
      'removeBudgetstoChild',
      'gotoCard',
      'getTeams',
      'moveBudgetstoChild',
      'splitMyTransaction',
      'deleteMySplitTransactions',
      'isValidAmount',
      'deleteExtTransaction',
    ]),
    ...mapActions('tags', ['getUserExpenseTags', 'addTagToTransactions', 'markFlagcmp']),
    deleteTransaction(value) {
      if (value.isExternal && value.splitTransactions.length < 2) {
        this.deleteExtTransaction(value);
      } else {
        this.$message({
          message: 'Delete not allowed.',
          type: 'error',
        });
      }
    },
    validateTotalAmount() {
      if (this.form.splitTransactions.length) {
        const { originalAmount } = this.form;
        const amount = this.form.splitTransactions.reduce((a, b) => Number(a) + Number(b.amount), 0);
        console.log('amount, originalAmount)', amount, originalAmount);
        if (amount !== originalAmount) {
          this.isValidAmount(false);
        } else {
          this.isValidAmount(true);
        }
      }
    },
    getFlagTitle(value) {
      if (value) {
        return 'Unflag';
      }
      return 'Flag';
    },

    splitAllwed() {
      console.log('splitAllwed');
    },
    splitTransactions() {
      this.form.splitTransactions.push({
        id: '',
        selectedCompany: '',
        teamId: '',
        categoryId: '',
        month: this.form.month,
        year: this.form.year,
        expenseDate: this.form.expenseDate1,
        amount: Number(0),
        isMainTransaction: false,
      });
      this.inlineComponents.push(InlineSplitTransaction);
    },
    splitRemoveTransactions(value) {
      const index = this.form.splitTransactions.findIndex(o => o.id === value.remove);
      if (index !== -1) this.form.splitTransactions.splice(index, 1);
      // re-calcualte Validation
      this.validateTotalAmount();
    },
    markFlag() {
      this.isDeleteOne = true;
      this.markFlagcmp({
        id: this.form.expenseId,
        isFlagged: !this.form.isFlagged,
      });
      this.form.isFlagged = !this.form.isFlagged;
      this.buttonRefreshkey = new Date().toString();
    },
    handleCommand() {
      this.seletedCategory = null;
      this.seletedTeam = null;
      this.getTags();
      this.getTeams({ id: this.selectedCompany });
      // get list of Team;
    },
    handleCommandSelectTeam(value) {
      const list = this.selectedTeams.filter(item => item.id === value);
      this.listCategory = list[0].categories;
      this.seletedCategory = null;
    },
    getTags(value) {
      const companyId = this.selectedCompany ? this.selectedCompany : this.userCompanyId;
      if (this.form.expenseDate && value) {
        this.getUserExpenseTags({
          Company: companyId,
          team: value,
          currentDate: new Date(this.form.expenseDate),
        });
      } else {
        this.getUserExpenseTags({
          Company: companyId,
          currentDate: new Date(this.form.expenseDate),
        });
      }
    },
    changeUETag() {
      const tagName = this.inputValue;
      this.form.transactionTag = [];
      const tagList = this.allTags;
      const selectedTag = tagList.find(tag => tag.value.toLowerCase() === tagName.toLowerCase());
      this.form.transactionTag.push({ name: selectedTag.value, id: selectedTag.id });
      this.tagAction = 'add';
      this.tagId = selectedTag.id;
      this.inputValue = '';
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleCloseTag(value) {
      if (this.form.transactionTag.length > 0 && !this.tagAction) {
        this.prevTag = this.form.transactionTag[0].id;
      }
      this.tagId = value.id;
      this.tagAction = 'remove';
      this.form.transactionTag = [];
      this.$forceUpdate();
    },
    querySearchAsync(queryString, cb) {
      const { allTags } = this;
      const results = queryString ? allTags.filter(this.createFilter(queryString)) : allTags;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return allTags => allTags.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    },
    vCardClicked(value) {
      this.gotoCard({ id: value.userId });
      if (value.card.group && value.card.category) {
        this.$router.push(`/budget/${value.card.category.id}/${value.card.group.id}`, () => {});
      }
    },
    pCardClicked(value) {
      if (value.user) {
        this.$router.push('/physical-cards', () => {});
      }
    },
    groupClikedPhysical() {
      this.$router.push('/budget/allTeam', () => {});
    },
    groupCliked(value) {
      if (value.group) {
        this.$router.push(`/budget/${value.group.id}`, () => {});
      }
    },
    categoryCliked(value) {
      if (value.category) {
        this.$router.push(`/budget/${value.category.id}/${value.group.id}`, () => {});
      }
    },

    getlastFour(value) {
      return value === null ? { last_four: 0 } : { last_four: value.last_four };
    },
    setBacktoNormal() {
      let id = null;
      if (!this.form.categoryId) {
        id = 1;
      }
      this.removeBudgetstoChild({
        id: this.form.expenseId,
        categoryId: id,
      });
    },


    mapMerchant(value) {
      let recordStatus = 0;
      this.isChecked = false;
      if (value) {
        recordStatus = 1;
        this.isChecked = true;
      }


      const {
        categoryId,
        groupId,
        isPhysical,
        merchantid,
        isExternal,
      } = this.form;
      const cardId = this.form.card.id;
      const compId = this.userCompanyId;

      const merchantMapData = {
        categoryId,
        groupId,
        cardId,
        compId,
        merchantid,
        recordStatus,
      };

      if (this.form.groupId === '' || this.form.groupId === undefined) {
        merchantMapData.groupId = this.groupId;
      }

      if (this.form.categoryId === '' || this.form.categoryId === undefined) {
        merchantMapData.categoryId = this.categoryId;
      }


      if (merchantMapData.groupId === '' || merchantMapData.groupId === undefined) {
        this.isChecked = false;
        return;
      }

      if (merchantMapData.categoryId === '' || merchantMapData.categoryId === undefined) {
        this.isChecked = false;
        return;
      }
      if (isPhysical || isExternal) {
        this.mapMerchantforPhysicalCard(merchantMapData);
      }
    },

    mapAllMerchant() {
      const {
        categoryId,
        groupId,
        isPhysical,
        merchantid,
        childMerchantid,
        isExternal,
      } = this.form;
      const cardId = this.form.card.id;
      const compId = this.userCompanyId;


      const merchantMapData = {
        categoryId,
        groupId,
        cardId,
        compId,
        parentMerchantId: merchantid,
        merchantid: childMerchantid,
      };

      if (this.form.groupId === '' || this.form.groupId === undefined) {
        merchantMapData.groupId = this.groupId;
      }

      if (this.form.categoryId === '' || this.form.categoryId === undefined) {
        merchantMapData.categoryId = this.categoryId;
      }


      if (merchantMapData.groupId === '' || merchantMapData.groupId === undefined) {
        this.$message({
          message: 'Please select valid Team.',
          type: 'error',
        });
        this.isChecked = false;
        return;
      }

      if (merchantMapData.categoryId === '' || merchantMapData.categoryId === undefined) {
        this.$message({
          message: 'Please select valid Category.',
          type: 'error',
        });
        this.isChecked = false;
        return;
      }

      if (isPhysical || isExternal) {
        // Call API Method here
        this.mapAllMapMerchantToTeam(merchantMapData);
      }
    },
    beforeRemove() {
      // for Permission

      if (this.isPermission) {
        return true;
      }
      this.$message({
        message: 'You are not authorized to remove receipts.',
        type: 'warning',
      });
      return false;
    },

    handleRemoveReceipt(file) {
      this.uploadedReceipts.splice(
        this.uploadedReceipts.findIndex(item => item.id === file.id),
        1,
      );
      // REmove form Filelist
      if (file.id) {
        this.fileListRemove.push({ id: file.id });
      }
    },

    handlePreview(file) {
      window.open(file.url, '_blank');
    },

    updateCategory(value, isOnCreate) {
      // Reset null category in selection of new Team;
      if (isOnCreate !== 'onCreate') {
        this.categoryId = null;
      }
      if (value) {
        this.$emit('handleParentDropdown', {
          teamId: value,
          categoryId: this.categoryId,
          uploadFlag: this.uploadFlag,
        });
        if (this.form.userId) {
          this.getUserRoleForTeam({
            userId: this.form.userId,
            recordStatus: 1,
            teamId: value,
          });
        }
        this.getUserUnCategorized({
          month: Number(localStorage.getItem('selectedMonth')),
          year: Number(localStorage.getItem('selectedYear')),
          id: value,
        });
        this.getTags(value);
      }
    },
    categoryBudgetUser(value) {
      //  Avoid following calculation for AllCompanny Admin;
      if (!this.me.isAllCompanyAdmin) {
        this.$emit('handleParentDropdown', {
          teamId: this.groupId,
          categoryId: value,
          uploadFlag: this.uploadFlag,
        });
        const tempDate = new Date(this.form.expenseDate);
        this.getCategoryBudgetCalculation({
          categoryId: [value],
          month: tempDate.getMonth() + 1, // Number(localStorage.getItem('selectedMonth')),
          year: tempDate.getFullYear(), // Number(localStorage.getItem('selectedYear')),
          userStatus: this.userRoleUploadReceipt,
          userId: this.form.userId,
        });
      }
    },
    formatDate(value) {
      return moment(value).format('MM/DD/YYYY');
      // return moment(value, 'MM/DD/YYYY');
    },
    handleClose(value) {
      this.description = '';
      this.groupId = '';
      this.categoryId = '';
      this.imageUrl = '';
      this.file = null;
      this.userId = null;
      this.fileType = null;
      this.category = [];
      this.fileListRemove = [];
      if (this.isDeleteOne) {
        this.$emit('handleParentClose');
      } else {
        this.$emit('handleParentClose', value);
      }
      this.form.transactionTag = [];
    },

    submitReceipt() {
      let isCompanyAvailable = false;
      if (this.form.splitTransactions.length > 1) {
        this.form.splitTransactions.forEach((item) => {
          if (item.selectedCompany === '') {
            isCompanyAvailable = true;
          }
        });
      }

      if (isCompanyAvailable) {
        this.$message({
          message: 'Please Enter Valid Company Id',
          type: 'error',
        });
        return 0;
      }

      if (!this.isAmountValid) {
        this.$message({
          message: 'Please Enter Valid calculation ',
          type: 'error',
        });
        return 0;
      }
      const {
        userId,
        qbSyncStatus,
        qbSyncId,
        description,
      } = this.form;

      if (!this.description) {
        this.description = description;
      }

      if (!this.groupId) {
        this.groupId = this.form.groupId;
      }

      if (!this.categoryId) {
        this.categoryId = this.form.categoryId;
      }

      if (!this.descriptionFlag) {
        this.descriptionFlag = this.form.descriptionFlag;
      }

      if (!this.userId) {
        this.userId = userId;
      }

      this.uploadFlag = 1;
      const value = {
        expenseId: this.form.expenseId,
        groupId: this.groupId,
        categoryId: this.categoryId,
        uploadFlag: this.uploadFlag,
        description: this.description,
        receipts: this.uploadedReceipts,
        descriptionFlag: this.descriptionFlag,
        userId: this.userId,
        qbSyncStatus,
        qbSyncId,
        deleteReceipt: this.fileListRemove,
        selectedCompany: this.selectedCompany,
        originCompany: this.form.companyId,
        isSplit: this.makeSplit,
        tagAction: this.tagAction,
        tagId: this.tagId,
        prevTag: this.prevTag,
      };
      if (this.mapMerchantToCategorygroup) {
        if (this.mapMerchantToCategorygroup.recordStatus === 1 && !this.isChecked) {
          this.mapMerchant(false);
        }
      }
      if (this.isChecked) {
        this.mapAllMerchant();
        this.mapMerchant(true);
      }
      value.splitMyTransaction = this.form;
      value.deleteMySplitTransactions = this.deleteSplitTransactions;

      this.$emit('handleParentSubmit', value);
      return 0;
    },
    checkFileMime(value) {
      const type = value.split('.').pop();
      const extension = type.split('?').shift();
      return extension !== 'pdf';
    },
    handleAvatarSuccess(res) {
      // available aurgs: res, file
      // To Display Updated image
      // logic
      this.fileType = res.raw.type;
      this.file = res;
      this.imageUrl = URL.createObjectURL(res.raw);
      const fileItems = {
        fileType: res.raw.type,
        fileSelected: res,
        image: URL.createObjectURL(res.raw),
      };
      this.uploadedReceipts.push(fileItems);
      const a = this.fileList.length - 1;
      if (a >= 0) {
        this.fileList[a].url = this.fileList[a].fileSelected.url;
        this.fileList[a].name = this.fileList[a].fileSelected.name;
      }
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 0px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 157px;
  height: 170px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.break {
  margin-top: 60px;
  padding-left: 20px;
  padding-right: 20px;
  border-top-color: #d9d9d9;
  border-top-width: 1px;
}
.textColorDialog {
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 10px;
}
.cancelIcon {
  position: absolute;
  right: 7px;
  top: 5px;
}
</style>
